import http from './http';

export async function createAdminUser({ email, nom, prenom }) {
  const { data } = await http.post('/admin/users', { email, nom, prenom });
  return data;
}

export async function deleteAdminUser(id) {
  await http.delete(`/admin/users/${id}`);
}

export async function rejectAdminUser(id) {
  const { data } = await http.post(`/admin/users/${id}/reject`, {});
  return data;
}

export async function unlinkGoogleFromUser(id) {
  const { data } = await http.post(`/admin/users/${id}/unlink-google`, {});
  return data;
}
